import React, { useEffect, useRef, useState } from "react";
import { MdSearch } from "react-icons/md";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchWorkEntries,
  fetchWorkEntriesProjectTracking,
} from "../../../../../store/slices/workentriesSlice";
import {
  fetchDescriptionTasks,
  fetchDescriptionTasksProjectTracking,
} from "../../../../../store/slices/DescriptionTask";
import {
  fetchHardwareDescriptions,
  fetchHardwareProjectTracking,
} from "../../../../../store/slices/hardwareDescriptionSlice";
import { fetchEmployees } from "../../../../../store/slices/employeeSlice";
import AdminLoader from "../../../../../components/common/loader/AdminLoader";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ShowTaskDetailsCompleted from "./ShowTaskDetailsCompleted";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import FileUploadSales from "../ResponseReceived/FileUploadSales";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { setLeadReadTrue } from "../../../../../store/slices/readSlice";
import DateConversion from "../../../../../utils/DateConversion";
import { fetchGroups } from "../../../../../store/slices/groupSlice";
import { getMyTrainings } from "../../../../../store/slices/MyTraining/myTrainings";

const ProjectCompletedSales = ({ salesCompletedGroupProject, handlerefresh, leads, isViewOnly = false }) => {
  const dispatch = useDispatch();
  const { formatDateByCountry } = DateConversion();
  const { employees } = useSelector((state) => state.employees);
  const { projects } = useSelector((state) => state.projects);
  const { group: masterGroups } = useSelector((state) => state.group);
  const { tasks } = useSelector((state) => state.descriptionTasks);
  const { entries } = useSelector((state) => state.workentries);

  // const { items } = useSelector((state) => state.hardwareDescription);
  const [currentProject, setCurrentProject] = useState(null);
  const [showAttach, setShowAttach] = useState(false);
  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );
  const { descriptionProjectTracking } = useSelector(
    (state) => state.descriptionTasks
  );

  useEffect(() => {
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(fetchWorkEntries());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchEmployees());
    dispatch(fetchAllProjects());
    dispatch(fetchGroups());
    dispatch(getMyTrainings());
  }, [dispatch]);

  const [isLoading] = useState(false);

  const [sortedProjects, setSortedProjects] = useState([]);
  const resolveId = (value) => {
    if (!value) return "";
    if (typeof value === "string" || typeof value === "number") {
      return String(value).trim();
    }
    return String(value?._id || value?.id || "").trim();
  };

  const getGroupDisplayName = (row) => {
    const groupId =
      resolveId(row?.projectdata?.groupid) ||
      resolveId(row?.groupid) ||
      resolveId(row?.lead?.groupid);

    if (!groupId) return "";

    const matchedGroup = (masterGroups || []).find(
      (group) => resolveId(group?._id) === groupId
    );

    return (
      matchedGroup?.newGroupName ||
      matchedGroup?.GroupName ||
      matchedGroup?.groupName ||
      matchedGroup?.name ||
      ""
    );
  };

  useEffect(() => {
    setSortedProjects(salesCompletedGroupProject);
  }, [salesCompletedGroupProject]);

  const itemsPerPage = 10; // or any number of rows you want per page
  const [currentPage, setCurrentPage] = useState(1);

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1);
    filterLeadReports(query)
  };

  const totalItems = sortedProjects.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const paginatedProjects = sortedProjects.slice(startIdx, endIdx);

  const filterLeadReports = (query) => {
    const lowerCaseQuery = query.toLowerCase().trim();

    const filtered = salesCompletedGroupProject.filter((LeadReport) =>
      Object.entries(LeadReport).some(([key, value]) => {
        // Skip these keys
        if (
          key === "Assignedperson" ||
          key === "TypeService" ||
          key === "SalesPersonName" ||
          key === "SalesPersonEmail" ||
          key === "ResourceType" ||
          key === "QuotedValue" ||
          key === "ProjectManagerStatus" ||
          key === "ProjectManagerAction" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "PrimaryResources"
        )
          return false;

        if (value === null || value === undefined) return false;
        if (key === "DateRequested" || key === "ProjectDueDate") {
          const formattedDate = formatDateByCountry(value);  // ← change here
          return formattedDate.toLowerCase().includes(lowerCaseQuery);
        }
        if (key === "AssignedGroup" || key === "groupid") {
          const groupName = getGroupDisplayName(LeadReport).toLowerCase();
          return groupName.includes(lowerCaseQuery);
        }

        // Handle all other fields
        const formattedValue = value.toString().trim().toLowerCase();
        return formattedValue.includes(lowerCaseQuery);
      })
    );

    setSortedProjects(filtered);
  };

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;
    let sorted = [...sortedProjects]; // Always sort from the filtered dataset

    const compareStrings = (a, b) => {
      const valA = (a || "").toString().toLowerCase();
      const valB = (b || "").toString().toLowerCase();
      return valA.localeCompare(valB);
    };
    // Helper function for date comparison
    const compareDates = (a, b) => {
      const dateA = a ? new Date(a) : null;
      const dateB = b ? new Date(b) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA - dateB;
    };

    switch (key) {
      case "AssignedGroup-az":
        sorted.sort((a, b) =>
          compareStrings(getGroupDisplayName(a), getGroupDisplayName(b))
        );
        break;
      case "AssignedGroup-za":
        sorted.sort((a, b) =>
          compareStrings(getGroupDisplayName(b), getGroupDisplayName(a))
        );
        break;
      case "ProjectName-az":
        sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
        break;
      case "ProjectName-za":
        sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
        break;
      case "DateRequested-az":
        sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
        break;
      case "DateRequested-za":
        sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
        break;
      case "ProjectDueDate-az":
        sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
        break;
      case "ProjectDueDate-za":
        sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
        break;
      default:
        // Default to original filtered order
        sorted = [...sortedProjects];
        break;
    }

    setSortedProjects(sorted);
    setCurrentPage(1); // Reset to first page after sorting
  };

  const [rowName, setRowName] = useState(null)
  const [showListState, setShowListState] = useState("tasktable")
  const [rowID, setRowID] = useState(null)
  const [clickedProject, setClickedProject] = useState(null)

  const ProjectCompleteRef = useRef(null);
  useEffect(() => {
    if ((rowName)) {
      const scrollToPosition = ProjectCompleteRef.current.scrollWidth;
      ProjectCompleteRef.current.scrollTo({
        left: scrollToPosition,
        behavior: 'smooth'
      });
    }
  }, [rowName]);

  const handleleadread = async (row) => {
    if (isViewOnly) return;
    const matchedLead = leads.find((lead) =>
      (row.quotationId != null && lead.quotationId != null)
        ? String(lead.quotationId) === String(row.quotationId)
        : lead?.ProjectName === row.ProjectName
    );
    if (!matchedLead) return;
    if (matchedLead.isRead === false) {
      const quotationId = matchedLead.quotationId;
      try {
        if (quotationId) await dispatch(setLeadReadTrue(quotationId));
      } catch (error) {
        console.error("Error updating Notes:", error);
      } finally {
        handlerefresh()
      }
    }

  };

  return (
    <div className="">
      <>
        {isLoading ? <AdminLoader isLoading={isLoading} /> : <> </>}
        <div className="pt-2">
          <div className="bg-white rounded-t flex justify-between items-center p-2">
            <div className=" font-semibold">
              <h3>Project Completed</h3>
            </div>

            <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
              <MdSearch className=" w-5 h-5 text-gray-500" />
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearchInputChange}
                placeholder="Search"
                className="bg-[#e0e7ff] outline-none w-[80%]"
              />
            </div>
          </div>
          <div
            ref={ProjectCompleteRef}
            className="w-full  bg-white h-full  min-h-[20vh] max-h-[90vh] overflow-auto pb-5 ">
            <div className="">
              <div
                className="sticky top-0 bg-[#e8e8e8] z-[1299]">
                <div className="flex w-full bg-[#e8e8e8] text-xs  text-center font-semibold">
                  <div className={`flex ${rowName ? "" : "w-[80%]"} `}>
                    <div className="w-14  flex justify-center items-center">Sr. No</div>
                    <div className={`${rowName ? "w-28" : "w-[20%]"}  p-2 break-words text-wrap flex justify-between items-center align-middle `}>
                      Group
                      <div className="flex flex-col">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("AssignedGroup", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("AssignedGroup", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={`${rowName ? "w-28" : "w-[20%]"}  p-2 break-words text-wrap flex justify-between items-center align-middle `}>
                      Project
                      <div className="flex flex-col">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("ProjectName", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("ProjectName", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={`${rowName ? "w-36" : "w-[20%]"} relative  p-2 break-words text-wrap flex justify-center items-center align-middle `}>
                      Date  Requested{" "}
                      <div className="flex flex-col absolute right-1">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("DateRequested", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("DateRequested", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={`${rowName ? "w-28" : "w-[20%]"} relative p-2 break-words text-wrap flex justify-center items-center align-middle `}>
                      Due Date
                      <div className=" flex flex-col absolute right-1">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("ProjectDueDate", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("ProjectDueDate", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={`${rowName ? "w-28" : "w-[20%]"}  p-2 break-words text-wrap flex justify-center items-center `}>
                      Attachment
                    </div>
                  </div>

                  {rowName ? (
                    <div className="flex w-full">
                      <div className="w-36 flex shrink-0 bg-[#e8e8e8]  p-2 break-words text-wrap justify-center items-center">
                        Manager Details
                      </div>
                      <div className="w-[36rem] bg-[#e8e8e8]  break-words text-wrap">
                        <div className="w-full h-[50%] p-2  break-words text-wrap flex justify-center items-center" >
                          Task Details
                        </div>
                        <div className="w-full h-[50%]  break-words text-wrap flex ">
                          <div
                            onClick={() => setShowListState("tasktable")}
                            className={`w-[50%]  ${showListState === "tasktable" ? "bg-blue-500 text-white" : ""} p-2 cursor-pointer flex justify-center items-center`}>
                            {clickedProject?.TypeService?.toLowerCase().includes("hardware") ? "Part List" : "Effort Expenses"}
                            {/* {clickedProject?.TypeService === "Hardware" ? "Part List" : "Effort Expenses"} */}
                          </div>
                          <div
                            onClick={() => setShowListState("otherexpenses")}
                            className={` w-[50%] ${showListState === "otherexpenses" ? "bg-blue-500 text-white" : ""} p-2 cursor-pointer flex justify-center items-center`}>
                            Other Expenses
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className={`w-[20%] bg-[#e8e8e8] p-2  flex justify-center items-center `}>
                      Task Details
                    </div>
                  )}
                </div>
              </div>

              <div className="w-full">
                {paginatedProjects.map((row, index) => {
                  const rowKey = row.quotationId ?? row.ProjectName;
                    return (
                    <div
                      className={`flex text-xs ${row.isRead === false ? "font-bold" : " "} cursor-pointer group w-full`}
                      key={rowKey ?? index}
                    >
                      <div className={`flex ${rowName ? "" : "w-[80%]"} `}>
                        <div onClick={() => {
                          const isOpening = rowName === rowKey;

                          setRowName(rowName === rowKey ? null : rowKey);
                          setRowID(rowID === row._id ? null : row._id);
                          setClickedProject(clickedProject === row ? null : row);
                          if (isOpening) {
                            handleleadread(row)
                          }
                        }}
                          className="w-14 p-2 border-b flex justify-start items-center group-hover:bg-gray-100">
                          {startIdx + index + 1}{" "}
                        </div>
                        <div onClick={() => {
                          const isOpening = rowName === rowKey;

                          setRowName(rowName === rowKey ? null : rowKey);
                          setRowID(rowID === row._id ? null : row._id);
                          setClickedProject(clickedProject === row ? null : row);
                          if (isOpening) {
                            handleleadread(row)
                          }
                        }}
                          className={`${rowName ? "w-28" : "w-[20%]"} border-b group-hover:bg-gray-100 flex justify-start align-middle items-center p-2 break-words text-wrap `}>
                          {getGroupDisplayName(row)}
                        </div>
                        <div onClick={() => {
                          const isOpening = rowName !== rowKey;

                          setRowName(rowName === rowKey ? null : rowKey);
                          setRowID(rowID === row._id ? null : row._id);
                          setClickedProject(clickedProject === row ? null : row);
                          if (isOpening) {
                            handleleadread(row)
                          }
                        }}
                          className={`${rowName ? "w-28" : "w-[20%]"} border-b group-hover:bg-gray-100 flex justify-start align-middle items-center text-left p-2 break-words whitespace-normal overflow-hidden text-ellipsis line-clamp-2 leading-snug text-xs`}>
                          {row.ProjectName}
                        </div>
                        <div onClick={() => {
                          const isOpening = rowName !== rowKey;

                          setRowName(rowName === rowKey ? null : rowKey);
                          setRowID(rowID === row._id ? null : row._id);
                          setClickedProject(clickedProject === row ? null : row);
                          if (isOpening) {
                            handleleadread(row)
                          }
                        }}
                          className={`${rowName ? "w-36" : "w-[20%]"} border-b group-hover:bg-gray-100 flex justify-center align-middle items-center  p-2 break-words text-wrap `}>
                          {row.DateRequested &&
                            !isNaN(new Date(row.DateRequested))
                            ? formatDateByCountry(row.DateRequested)
                            : ""}
                        </div>
                        <div onClick={() => {
                          const isOpening = rowName !== rowKey;

                          setRowName(rowName === rowKey ? null : rowKey);
                          setRowID(rowID === row._id ? null : row._id);
                          setClickedProject(clickedProject === row ? null : row);
                          if (isOpening) {
                            handleleadread(row)
                          }
                        }}
                          className={`${rowName ? "w-28" : "w-[20%]"} border-b group-hover:bg-gray-100  flex justify-center align-middle items-center  p-2 break-words text-wrap `}>
                          {row.ProjectDueDate &&
                            !isNaN(new Date(row.ProjectDueDate))
                            ? formatDateByCountry(row.ProjectDueDate)
                            : ""}
                        </div>
                        <div className={`${rowName ? "w-28" : "w-[20%]"} border-b group-hover:bg-gray-100 p-2 flex justify-center align-middle items-center text-center break-words text-wrap `}>
                          <AttachFileIcon className="rotate-12 cursor-pointer"
                            onClick={() => {
                              setCurrentProject(row);
                              setShowAttach(true);
                            }} />
                        </div>
                      </div>

                      {rowName === rowKey ? (
                        <div className=" flex flex-col group-hover:bg-gray-100 w-full">
                          <ShowTaskDetailsCompleted
                            row={row}
                            showListState={showListState}
                            index={index}
                            employees={employees}
                            projects={projects}
                            projectTrackingWorkEntries={
                              projectTrackingWorkEntries
                            }
                            descriptionProjectTracking={
                              descriptionProjectTracking
                            }
                            hardwareProjectTracking={hardwareProjectTracking}
                            entries={entries}
                            tasks={tasks}
                            isViewOnly={isViewOnly}
                          />
                        </div>
                      ) : (
                        <div
                          onClick={() => setRowName(rowName === rowKey ? null : rowKey)}
                          className={`${rowName ? "w-full" : "w-[20%]"} border-b  group-hover:bg-gray-100 cursor-pointer flex justify-center items-center`}
                        >
                          {rowName ? (
                            <div onClick={() => {
                              const isOpening = rowName !== rowKey;

                              setRowName(rowName === rowKey ? null : rowKey);
                              setRowID(rowID === row._id ? null : row._id);
                              setClickedProject(clickedProject === row ? null : row);
                              if (isOpening) {
                                handleleadread(row)
                              }
                            }}
                              className="flex justify-center items-center w-full">
                              <div className="w-36">
                              </div>
                              <div className="w-[36rem] pl-20">
                                Multiple
                              </div>
                            </div>
                          ) : (
                            <div onClick={() => {
                              const isOpening = rowName !== rowKey;

                              setRowName(rowName === rowKey ? null : rowKey);
                              setRowID(rowID === row._id ? null : row._id);
                              setClickedProject(clickedProject === row ? null : row);
                              if (isOpening) {
                                handleleadread(row)
                              }
                            }}
                              className="w-full  p-2 flex justify-center items-center">
                              Multiple
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
                {paginatedProjects.length === 0 && (
                  <div className="noDataAvailable p-2">No Result Found</div>
                )}
              </div>
            </div>
          </div>
          <div
            className={`pagination flex justify-between  text-xs items-center bg-white pb-2 pl-2 rounded-md ${paginatedProjects.length > 0 ? "p-1" : ""
              } `}
          >
            <div>
              {totalItems > 0 ? (
                <>
                  Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                  {totalItems} Entries
                </>
              ) : (
                <>
                  {paginatedProjects.length > 0 && (
                    <>Showing {paginatedProjects.length} Entries</>
                  )}
                </>
              )}
            </div>


            {totalPages > 1 && (
              <div className="flex">
                <button
                  onClick={() => setCurrentPage(1)}
                  className="px-2 py-2 mx-1 border rounded"
                  disabled={currentPage === 1}
                  title="First Page"
                >
                  <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                </button>
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  className="px-2 py-2 mx-2 border rounded"
                  disabled={currentPage === 1}
                >
                  <ChevronRightIcon className="w-5 h-5 rotate-180" />
                </button>

                {Array.from({ length: 3 }, (_, index) => {
                  const pageNumber = currentPage - 1 + index;
                  if (pageNumber >= 1 && pageNumber <= totalPages) {
                    return (
                      <button
                        key={pageNumber}
                        onClick={() => setCurrentPage(pageNumber)}
                        className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber
                          ? "bg-gray-300"
                          : ""
                          }`}
                      >
                        {pageNumber}
                      </button>
                    );
                  }
                  return null;
                })}

                <button
                  onClick={() =>
                    setCurrentPage((prev) =>
                      Math.min(prev + 1, totalPages)
                    )
                  }
                  className="px-2 py-2 mx-2 border rounded"
                  disabled={currentPage === totalPages}
                >
                  <ChevronRightIcon className="w-5 h-5" />
                </button>

                <button
                  onClick={() => setCurrentPage(totalPages)}
                  className="px-2 py-2 mx-1 border rounded"
                  disabled={currentPage === totalPages}
                  title="Last Page"
                >
                  <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                </button>
              </div>
            )}

          </div>

          {showAttach && (
            <FileUploadSales
              currentProject={currentProject}
              setShowAttach={setShowAttach}
              employees={employees}
              isViewOnly={isViewOnly}
            />
          )
          }

        </div>
      </>
    </div>
  );
};

export default ProjectCompletedSales;
